import { useState } from 'react';

import {
  LessonFragment,
  LessonsQueryVariables,
} from '@school_ify/schoolify-repository/src/shared/types';

import ClassesService from 'domain/services/student/dashboard/classes';

export default function useClasses() {
  const [lessons, setLessons] = useState<LessonFragment[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function getLessons(data: LessonsQueryVariables) {
    setLoading(true);
    try {
      const classes = await ClassesService.getStudentLessonsByDate(data);
      if (classes) {
        setLessons(classes);
      }
    } catch (err) {
      setError(err);
      throw new Error(err);
    }

    setLoading(false);
  }
  return { lessons, isLoading, error, getLessons };
}
